export const types = {
    VERIFY_TOKEN_FOR_POLL_SUCCESS: 'VERIFY_TOKEN_FOR_POLL_SUCCESS',
    VERIFY_TOKEN_FOR_POLL_REQUEST: 'VERIFY_TOKEN_FOR_POLL_REQUEST',
    VERIFY_TOKEN_FOR_POLL_FAILURE: 'VERIFY_TOKEN_FOR_POLL_FAILURE',
    POLL_WAS_SEND_SUCCESS: 'POLL_WAS_SEND_SUCCESS',
    POLL_WAS_SEND_REQUEST: 'POLL_WAS_SEND_REQUEST',
    POLL_WAS_SEND_FAILURE: 'POLL_WAS_SEND_FAILURE',
    UNSUBSCRIBE_DAILY_POLL_SUCCESS: 'UNSUBSCRIBE_DAILY_POLL_SUCCESS',
    UNSUBSCRIBE_DAILY_POLL_REQUEST: 'UNSUBSCRIBE_DAILY_POLL_REQUEST',
    UNSUBSCRIBE_DAILY_POLL_FAILURE: 'UNSUBSCRIBE_DAILY_POLL_FAILURE',
};
